"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    NOT_IN_SCHEMA: 'notInSchema',
    REQUIRED: 'required',
    UNKNOWN_FIELD_TYPE: 'unknownFieldType',
    NOT_AN_ARRAY: 'notAnArray',
    NOT_AN_OBJECT: 'notAnObject',
    NOT_A_STRING: 'notAString',
    NOT_A_DATE: 'notADate',
    NOT_AN_INTEGER: 'notAnInteger',
    NOT_A_NUMBER: 'notANumber',
    NOT_AN_ID: 'notAnId',
    STRING_TOO_SHORT: 'stringTooShort',
    STRING_TOO_LONG: 'stringTooLong',
    NUMBER_TOO_SMALL: 'numberTooSmall',
    NUMBER_TOO_BIG: 'numberTooBig',
    NOT_A_BOOLEAN: 'notABoolean',
    NOT_AN_EMAIL: 'notAnEmail',
    NOT_UNIQUE: 'notUnique',
    NOT_AN_ALLOWED_VALUE: 'notAnAllowedValue'
};
